// ===========================================================================
// CDCI v2 — banco de trabajo del refactor del transcriptor (AI Scribe).
//
// Qué es (2026-11-02, ver docs/modulos/AIScribe/): un duplicado del CDCI donde
// TODO lo que no es transcripción se importa del v1 tal cual (templates,
// contexto, nota, MEAT, audit, cargos, firma — una sola fuente de verdad).
// El pipeline NUEVO del scribe vive en su MÓDULO PROPIO `src/modules/scribe`
// (F8-10); este banco solo lo monta (ScribeCaptureWindow en el encuentro).
// La copia v1 (transcriptionService, useTranscriptionSession, ScribeFloating-
// Window, ConversationReview, VisitTranscript viejo) se RETIRÓ en F2 (F2-10);
// el CDCI productivo conserva la suya hasta el despliegue con
// SCRIBE_V2_ENABLED (F8-11). Se conservan services/visitAudioStore.js y
// hooks/useVoiceNoteGuide.js (los usa el NoteTab del v1).
// Las dos páginas también son copias (recableadas) porque orquestan el scribe.
//
// ACCESO: mismo módulo RBAC que el v1 (`cdci`, 37) — la ruta /cdci-v2 está
// mapeada en app/AccessDenied/roleRoutePermissions.js. El gate de entorno
// (CDCI_V2_ENABLED, solo dev) decide si el módulo existe.
// ===========================================================================
import React, { lazy } from "react";
import { CDCI_BASE_PATH, CDCI_V2_ENABLED } from "./common/constants";

// Lazy: nada del módulo viaja en el bundle inicial.
const CdciSchedulePage = lazy(() => import("./pages/CdciSchedulePage"));
const CdciEncounterPage = lazy(() => import("./pages/CdciEncounterPage"));

// El módulo resuelve su propio gating: apagado exporta [] y la URL cae en el
// catch-all del router (patrón playground / coding-opportunities-v2).
export const cdciV2Routes = CDCI_V2_ENABLED
  ? [
      { path: CDCI_BASE_PATH, element: <CdciSchedulePage /> },
      { path: `${CDCI_BASE_PATH}/encounter/:appointmentId`, element: <CdciEncounterPage /> },
    ]
  : [];

export { CDCI_BASE_PATH as CDCI_V2_BASE_PATH, CDCI_V2_ENABLED } from "./common/constants";
